import type { Component } from "solid-js";
import type { IconProps } from "./types";

const TildeIcon: Component<IconProps> = (props = {}) => {
  const size = () => props.size || 12;
  const className = () => props.class || "";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="currentColor"
      class={`size-${size()} ${className()}`}
    >
      <path
        d="M4 8.5c.5-1 1.5-1.5 2.5-1.5s2 .5 3 1.5c1 1 2 1.5 3 1.5s2-.5 2.5-1.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"
      />
    </svg>
  );
};

export default TildeIcon;
